/* eslint no-use-before-define: 0 */

export const uuidv4 = function () {
  return '10000000-1000-4000-8000-100000000000'.replace(/[018]/g, (c) =>
    (+c ^ (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (+c / 4)))).toString(16),
  );
};

export const convertToRoman = function (int: any) {
  let roman: any = [];
  let i: any, k: any, replacement: any;
  let seq = ['I', 'V', 'X', 'L', 'C', 'D', 'M'];

  while (int > 999) {
    roman.push('M');
    int -= 1000;
  }
  while (int > 499) {
    roman.push('D');
    int -= 500;
  }
  while (int > 99) {
    roman.push('C');
    int -= 100;
  }
  while (int > 49) {
    roman.push('L');
    int -= 50;
  }
  while (int > 9) {
    roman.push('X');
    int -= 10;
  }
  while (int > 4) {
    roman.push('V');
    int -= 5;
  }
  while (int >= 1) {
    roman.push('I');
    int -= 1;
  }

  // Replace recurrences of 4 ('IIII' to 'IV')
  for (i = 0; i < roman.length; i++) {
    if (roman[i] == roman[i + 1] && roman[i] == roman[i + 2] && roman[i] == roman[i + 3]) {
      for (k = 0; k < seq.length; k++) {
        if (roman[i] == seq[k]) {
          replacement = seq[k + 1];
        }
      }
      roman.splice(i + 1, 3, replacement);
    }
  }

  // Converting incorrect recurrences ('VIV' to 'IX')
  for (i = 0; i < roman.length; i++) {
    if (roman[i] == roman[i + 2] && roman[i] != roman[i + 1]) {
      for (k = 0; k < seq.length; k++) {
        if (roman[i] == seq[k]) {
          replacement = seq[k + 1];
        }
      }
      roman[i + 2] = replacement;
      roman.splice(i, 1);
    }
  }

  roman = roman.join('');
  return roman;
};
